import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setTelegramApiBaseUrl(url) {
    api.setBaseUrl(url);
}
/**
 * List ALL destinations (incl. disabled/discovered rows awaiting enable), each
 * carrying its `topicFilter`, plus `availableTopics` — the active class catalog
 * the per-destination filter multi-select offers.
 */
export async function listTelegramDestinations() {
    return api.get('/api/telegram/destinations');
}
/** Toggle `enabled` and/or rename a destination. */
export async function updateTelegramDestination(id, body) {
    return api.patch(`/api/telegram/destinations/${id}`, body);
}
export async function deleteTelegramDestination(id) {
    const r = await api.del(`/api/telegram/destinations/${id}`);
    if (!r.ok)
        throw new Error(`delete failed ${r.status}`);
}
/**
 * Trigger a bulk re-render of every already-posted Telegram support card to its
 * current DB state (edit-in-place, never re-send). Fire-and-forget: server acks
 * 202 and the telegram-bot fans out internally. Gated `telegram.manage` server-side.
 */
export async function rerenderAllTelegramCards() {
    const r = await api.fetchRaw('/api/telegram/rerender-all', { method: 'POST' });
    if (!r.ok) {
        const text = await r.text().catch(() => '');
        throw new Error(`request failed ${r.status}: ${text || r.statusText}`);
    }
}
//# sourceMappingURL=api.js.map